import React from "react";
import WideContainer from "../../components/WideContainer";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import { Trans, withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { connect } from "react-redux";

import utils from "../../app/utils";
import VideoResult from "../../components/VideoResult";
import axios from "../../components/Axios";
import "../Search.css";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      results: [],
      loading: false,
      loading_results: false,
    };
  }

  componentDidMount() {
    let u = localStorage.getItem("user_id");
    if (u === null) {
      this.props.history.push("/login");
      return;
    }
  }

  componentWillUnmount() {}

  handleChange(o, e, v, r) {
    for (let i in v) {
      if (typeof v[i] === "string" && o != "search_folders")
        v[i] = { object: "Speech", value: v[i] };
    }
    this.setState({ [o]: v }, function () {
      //reload options for folder
      if (o == "search_folders") {
        this.loadItems();
      }
    });
  }

  submitQuery() {
    this.setState({ loading_results: true, results: [] });
    let q = document.getElementById('searchValue').innerText;
    let u = JSON.parse(localStorage.getItem("user"))
    axios
      .post("/search/semantic", {
        user_folder: u.user_folder.split('/').pop(),
        project_folder: this.props.project.project_folder,
        query: q,
      })
      .then(
        function (response) {
          let ts = []
          let res = []
          for(let r of response.data){
            ts.push([r.start_time, r.end_time]);
          }
          if(ts.length>0){
            res.push({
            times: ts,
            video: {
              project_name: this.props.project.project_name,
              project_folder: this.props.project.project_folder,
              video_file: this.props.videosrc
                .split("/")
                .pop(),
              },
            });
          }
          this.setState({
            results: res,
            loading_results: false,
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log(error);
          this.setState({ loading_results: false });
        }.bind(this)
      );
  }

  formatTimes(t) {
    return (
      "" + utils.formatDuration(t[0]) + "-" + utils.formatDuration(t[1]) + ""
    );
  }

  getChipIcon(o) {
    if (o >= 0) return <PersonIcon />;
    return null;
  }

  getPathUrl(i) {
    if (i === -1) return "/img/people.png";
    return (
      JSON.parse(localStorage.getItem("user")).user_folder +
      "/" +
      this.props.project.project_folder +
      "/tracks_thumbnails/" +
      i +
      ".jpg"
    );
  }
  chipClick(i,e){
    let div = document.createElement("span");
    div.innerHTML=i.char_name;
    div.contentEditable="false";
    document.getElementById("searchValue").append(div);
    //document.getElementById("searchValue").focus();
    var range = document.createRange();
    var sel = window.getSelection();

    range.setStart(div, 0);
    range.collapse(true);

    sel.removeAllRanges();
    sel.addRange(range);
  }

  render() {
    return (
      <>
        <WideContainer style={{ paddingTop: "32px" }}>
          <div className="searchBar" style={{ display: "block" }}>
            <div>
              {this.props.characters.items.map((i, k) => (
                <Chip key={"chip-"+i.char_id}
                  avatar={
                    <Avatar
                      alt={i.char_name}
                      src={this.getPathUrl(i.rep_track_id)}
                    />
                  }
                  label={i.char_name}
                  onClick={this.chipClick.bind(this, i)}
                />
              ))}
            </div>
            <div
              className="searchEditable"
              contentEditable={true}
              id="searchValue"
              suppressContentEditableWarning="true"
            ></div>
            <Autocomplete hidden
              multiple
              name="search_include"
              size="small"
              freeSolo
              loading={this.state.loading}
              options={this.props.characters.items}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={<Trans>Search for</Trans>}
                  variant="outlined"
                  className="conditionField"
                />
              )}
              onChange={this.handleChange.bind(this, "search_include")}
              value={this.state.search_include}
              getOptionLabel={(option) => option.char_name}
              renderTags={(value, getCustomizedTagProps) => {
                return value.map((option, index) => {
                  if (option.rep_track_id >= 0) {
                    return (
                      <Chip
                        size="small"
                        label={option.char_name}
                        icon={this.getChipIcon(option.rep_track_id)}
                        {...getCustomizedTagProps({ index })}
                      />
                    );
                  } else {
                    return option.char_name;
                  }
                });
              }}
              filterOptions={(options, params) => {
                if (options.inputValue !== "") {
                  options.push({
                    char_name: params.inputValue,
                  });
                }
                return options;
              }}
            />
            <Button
              className="Button ButtonPrimary"
              size="small"
              disabled={this.state.loading_result}
              endIcon={<SearchIcon />}
              onClick={this.submitQuery.bind(this)}
            >
              <Trans>Search</Trans>
            </Button>
          </div>

          {this.state.loading_results && (
            <CircularProgress
              style={{
                margin: "24px",
                display: "block",
                position: "absolute",
                left: "calc(50% - 12px)",
              }}
            />
          )}
          <div className="resultsArea" hidden={this.state.loading_results}>
            {this.state.results.map((i, k) => (
              <div className="resultDiv" key={"result-" + k}>
                <VideoResult result={i}></VideoResult>
              </div>
            ))}
          </div>
        </WideContainer>
      </>
    );
  }
}

const mapState = (state) => {
  return {
    characters: state.characters,
  };
};
export default withTranslation()(withRouter(connect(mapState)(Index)));
